// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import API_URL from "../../Config";
// import { IoClose } from "react-icons/io5";
// import { AiOutlineEye } from "react-icons/ai";
// import { FiDownload } from "react-icons/fi";
// import "./purchaseIndents.css";

// const ViewPurchaseIndent = ({ indentId, onClose, showSnackbar }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [indentData, setIndentData] = useState(null);

//   const statusOptions = [
//     { value: "Draft", label: "Draft", color: "#6c757d" },
//     { value: "Pending Approval", label: "Pending Approval", color: "#FFA500" },
//     { value: "Approved", label: "Approved", color: "#28a745" },
//     { value: "Completed", label: "Completed", color: "#007bff" },
//   ];

//   useEffect(() => {
//     if (indentId) fetchIndentDetails(indentId);
//   }, [indentId]);

//   const fetchIndentDetails = async (id) => {
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/barrel/indent/${id}`, {
//         headers: { Authorization: authKey },
//       });

//       setIndentData(response.data);
//     } catch (error) {
//       console.error("Error fetching indent:", error);
//       showSnackbar("Error fetching indent details");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = date.toLocaleString("en-US", { month: "short" });
//     const year = date.getFullYear();
//     const hours = String(date.getHours()).padStart(2, "0");
//     const minutes = String(date.getMinutes()).padStart(2, "0");
//     return `${day} ${month} ${year}, ${hours}:${minutes}`;
//   };

//   const formatDateOnly = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const handleViewDocument = (filePath) => {
//     if (filePath) {
//       const fullPath = `${API_URL}${filePath}`;
//       window.open(fullPath, "_blank");
//     }
//   };

//   const getStatusBadge = (status) => {
//     const statusConfig = statusOptions.find((s) => s.value === status) || {
//       color: "#6c757d",
//       label: status || "Unknown",
//     };

//     return (
//       <span
//         style={{
//           backgroundColor: `${statusConfig.color}20`,
//           color: statusConfig.color,
//           padding: "6px 16px",
//           borderRadius: "12px",
//           fontSize: "14px",
//           fontWeight: "600",
//           display: "inline-block",
//           border: `1px solid ${statusConfig.color}40`,
//         }}
//       >
//         {statusConfig.label}
//       </span>
//     );
//   };

//   const getDocumentByType = (type) => {
//     return indentData?.attachments?.find((att) => att.document_type === type) || null;
//   };

//   if (isLoading) {
//     return (
//       <div className="purchase_indent_popup-overlay">
//         <div className="purchase_indent_popup-modal" style={{ maxWidth: "1000px" }}>
//           <div style={{ padding: "40px", textAlign: "center" }}>
//             <div className="loader"></div>
//             <div>Loading...</div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!indentData) return null;

//   const { indent, items, attachments, invoice_details } = indentData;
//   const ioclApproval = getDocumentByType("IOCL Approval");
//   const invoiceDoc = getDocumentByType("Invoice");
//   const acknowledgmentDoc = getDocumentByType("Acknowledgement");

//   return (
//     <div className="purchase_indent_popup-overlay">
//       <div className="purchase_indent_popup-modal" style={{ maxWidth: "1000px", maxHeight: "90vh", overflow: "auto" }}>
//         <div className="purchase_indent_popup-header">
//           <div>
//             <h4>Purchase Indent Details</h4>
//             <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
//               {indent?.indent_number || "N/A"}
//             </p>
//           </div>
//           <span className="purchase_indent_close-btn" onClick={onClose}>
//             <IoClose />
//           </span>
//         </div>

//         <div className="purchase_indent_popup-body" style={{ padding: "30px" }}>
//           {/* Status and Basic Info Section */}
//           <div style={{ marginBottom: "30px" }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//               <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Basic Information</h5>
//               {getStatusBadge(indent?.indent_status)}
//             </div>

//             <div style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "20px",
//               backgroundColor: "#f8f9fa",
//               padding: "20px",
//               borderRadius: "8px"
//             }}>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Indent Number</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.indent_number || "N/A"}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Indent Date</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{formatDateOnly(indent?.indent_date)}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Expected Delivery</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{formatDateOnly(indent?.expected_delivery_date)}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Created Date</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{formatDate(indent?.created_at)}</div>
//               </div>
//             </div>
//           </div>

//           {/* Customer Information */}
//           <div style={{ marginBottom: "30px" }}>
//             <h5 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}>Customer Information</h5>
//             <div style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "20px",
//               backgroundColor: "#f8f9fa",
//               padding: "20px",
//               borderRadius: "8px"
//             }}>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Customer Name</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.customer_name || "N/A"}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>SAP Code</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.sap_code || "N/A"}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Customer Type</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.customer_type || "N/A"}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Email</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.email || "N/A"}</div>
//               </div>
//               <div>
//                 <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Contact Number</div>
//                 <div style={{ fontSize: "15px", fontWeight: "600" }}>{indent?.contact_number || "N/A"}</div>
//               </div>
//             </div>
//           </div>

//           {/* Products Section */}
//           <div style={{ marginBottom: "30px" }}>
//             <h5 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}>Products</h5>
//             <div style={{ border: "1px solid #ddd", borderRadius: "8px", overflow: "hidden" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ backgroundColor: "#f8f9fa" }}>
//                     <th style={{ padding: "12px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>SR</th>
//                     <th style={{ padding: "12px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>Product Code</th>
//                     <th style={{ padding: "12px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>Product Name</th>
//                     <th style={{ padding: "12px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>Quantity (KL)</th>
//                     <th style={{ padding: "12px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>No. of Barrels</th>
//                     <th style={{ padding: "12px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#666", borderBottom: "2px solid #ddd" }}>UOM</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {items && items.length > 0 ? (
//                     items.map((item, index) => (
//                       <tr key={item.id} style={{ borderBottom: index < items.length - 1 ? "1px solid #f0f0f0" : "none" }}>
//                         <td style={{ padding: "12px", fontSize: "14px" }}>{index + 1}</td>
//                         <td style={{ padding: "12px", fontSize: "14px", fontWeight: "500" }}>{item.product_code}</td>
//                         <td style={{ padding: "12px", fontSize: "14px" }}>{item.product_name}</td>
//                         <td style={{ padding: "12px", fontSize: "14px", textAlign: "right", fontWeight: "600" }}>{parseFloat(item.quantity).toFixed(2)}</td>
//                         <td style={{ padding: "12px", fontSize: "14px", textAlign: "right", fontWeight: "600" }}>{parseFloat(item.quantity_in_barrels).toFixed(2)}</td>
//                         <td style={{ padding: "12px", fontSize: "14px" }}>{item.uom}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ padding: "20px", textAlign: "center", color: "#999" }}>No products found</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* IOCL Approval Section */}
//           {ioclApproval && (
//             <div style={{ marginBottom: "30px" }}>
//               <h5 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}>IOCL Approval</h5>
//               <div style={{
//                 backgroundColor: "#d4edda",
//                 border: "1px solid #c3e6cb",
//                 borderRadius: "8px",
//                 padding: "20px",
//               }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
//                   <span style={{ color: "#28a745", fontSize: "24px" }}>✓</span>
//                   <h6 style={{ margin: 0, color: "#28a745", fontSize: "16px", fontWeight: "600" }}>
//                     Document Uploaded Successfully
//                   </h6>
//                 </div>
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "15px" }}>
//                   <div>
//                     <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Uploaded On</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500" }}>{formatDate(ioclApproval.uploaded_at)}</div>
//                   </div>
//                   <div>
//                     <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Document</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500", wordBreak: "break-all" }}>{ioclApproval.file_name}</div>
//                   </div>
//                 </div>
//                 <button
//                   type="button"
//                   onClick={() => handleViewDocument(ioclApproval.file_path)}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "8px 16px",
//                     backgroundColor: "transparent",
//                     border: "1px solid #28a745",
//                     borderRadius: "4px",
//                     color: "#28a745",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <AiOutlineEye size={18} />
//                   View Document
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Invoice Section */}
//           {invoice_details && invoice_details.length > 0 && (
//             <div style={{ marginBottom: "30px" }}>
//               <h5 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}>Invoice Details</h5>
//               <div style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//                 gap: "20px",
//                 backgroundColor: "#f8f9fa",
//                 padding: "20px",
//                 borderRadius: "8px",
//                 marginBottom: "15px"
//               }}>
//                 <div>
//                   <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>Invoice Quantity (KL)</div>
//                   <div style={{ fontSize: "15px", fontWeight: "600" }}>{parseFloat(invoice_details[0].invoice_quantity_kl).toFixed(2)}</div>
//                 </div>
//                 <div>
//                   <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px", fontWeight: "500" }}>No. of Barrels</div>
//                   <div style={{ fontSize: "15px", fontWeight: "600" }}>{invoice_details[0].barrel_count}</div>
//                 </div>
//               </div>

//               {invoiceDoc && (
//                 <div style={{
//                   backgroundColor: "#d4edda",
//                   border: "1px solid #c3e6cb",
//                   borderRadius: "8px",
//                   padding: "20px",
//                 }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
//                     <span style={{ color: "#28a745", fontSize: "24px" }}>✓</span>
//                     <h6 style={{ margin: 0, color: "#28a745", fontSize: "16px", fontWeight: "600" }}>
//                       Invoice Document Uploaded
//                     </h6>
//                   </div>
//                   <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "15px" }}>
//                     <div>
//                       <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Uploaded On</div>
//                       <div style={{ fontSize: "14px", fontWeight: "500" }}>{formatDate(invoiceDoc.uploaded_at)}</div>
//                     </div>
//                     <div>
//                       <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Document</div>
//                       <div style={{ fontSize: "14px", fontWeight: "500", wordBreak: "break-all" }}>{invoiceDoc.file_name}</div>
//                     </div>
//                   </div>
//                   <button
//                     type="button"
//                     onClick={() => handleViewDocument(invoiceDoc.file_path)}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "8px",
//                       padding: "8px 16px",
//                       backgroundColor: "transparent",
//                       border: "1px solid #28a745",
//                       borderRadius: "4px",
//                       color: "#28a745",
//                       fontSize: "14px",
//                       fontWeight: "500",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <AiOutlineEye size={18} />
//                     View Document
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Acknowledgment Section */}
//           {acknowledgmentDoc && (
//             <div style={{ marginBottom: "30px" }}>
//               <h5 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}>Acknowledgment</h5>
//               <div style={{
//                 backgroundColor: "#d4edda",
//                 border: "1px solid #c3e6cb",
//                 borderRadius: "8px",
//                 padding: "20px",
//               }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
//                   <span style={{ color: "#28a745", fontSize: "24px" }}>✓</span>
//                   <h6 style={{ margin: 0, color: "#28a745", fontSize: "16px", fontWeight: "600" }}>
//                     Document Uploaded Successfully
//                   </h6>
//                 </div>
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "15px" }}>
//                   <div>
//                     <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Uploaded On</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500" }}>{formatDate(acknowledgmentDoc.uploaded_at)}</div>
//                   </div>
//                   <div>
//                     <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Document</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500", wordBreak: "break-all" }}>{acknowledgmentDoc.file_name}</div>
//                   </div>
//                 </div>
//                 <button
//                   type="button"
//                   onClick={() => handleViewDocument(acknowledgmentDoc.file_path)}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     padding: "8px 16px",
//                     backgroundColor: "transparent",
//                     border: "1px solid #28a745",
//                     borderRadius: "4px",
//                     color: "#28a745",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <AiOutlineEye size={18} />
//                   View Document
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="purchase_indent_popup-footer">
//           <button
//             className="purchase_indent_btn purchase_indent_btn-cancel"
//             onClick={onClose}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewPurchaseIndent;

import React, { useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../../Config";
import { IoClose } from "react-icons/io5";
import { AiOutlineEye, AiOutlineFile } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";
import { BsFiletypePdf, BsFiletypeJpg, BsFiletypePng } from "react-icons/bs";
import "./purchaseIndents.css";

const ViewPurchaseIndent = ({ indentId, onClose, showSnackbar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [indentData, setIndentData] = useState(null);

  const statusOptions = [
    { value: "Draft", label: "Draft", color: "#6c757d" },
    { value: "Pending Approval", label: "Pending Approval", color: "#FFA500" },
    { value: "Approved", label: "Approved", color: "#28a745" },
    { value: "Completed", label: "Completed", color: "#007bff" },
  ];

  useEffect(() => {
    if (indentId) fetchIndentDetails(indentId);
  }, [indentId]);

  const fetchIndentDetails = async (id) => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/barrel/indent/${id}`, {
        headers: { Authorization: authKey },
      });

      setIndentData(response.data);
    } catch (error) {
      console.error("Error fetching indent:", error);
      showSnackbar("Error fetching indent details");
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return "0 KB";
    const kb = bytes / 1024;
    if (kb < 1024) {
      return `${kb.toFixed(2)} KB`;
    }
    const mb = kb / 1024;
    return `${mb.toFixed(2)} MB`;
  };

  //   const handleViewDocument = async (attachmentId) => {
  //     try {
  //       const authKey = localStorage.getItem("authKey");
  //       const url = `${API_URL}/api/barrel/indent/${indentId}/attachments/${attachmentId}/view`;
  //       window.open(`${url}?auth=${authKey}`, "_blank");
  //     } catch (error) {
  //       console.error("Error viewing document:", error);
  //       showSnackbar("Error viewing document");
  //     }
  //   };

  const handleViewDocument = async (attachmentId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const viewUrl = `${API_URL}/api/barrel/indent/${indentId}/attachments/${attachmentId}/view`;

      const response = await axios.get(viewUrl, {
        headers: {
          Authorization: authKey,
        },
        responseType: "blob",
      });

      const contentType =
        response.headers["content-type"] || "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);

      const newWindow = window.open("", "_blank");

      if (contentType.startsWith("image/")) {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              body { 
                margin: 0; 
                padding: 20px; 
                display: flex; 
                justify-content: center; 
                align-items: center; 
                min-height: 100vh;
                background-color: #f0f0f0;
              }
              img { 
                max-width: 100%; 
                max-height: 100vh; 
                object-fit: contain;
                box-shadow: 0 4px 8px rgba(0,0,0,0.1);
              }
            </style>
          </head>
          <body>
            <img src="${fileURL}" alt="Document Preview" />
          </body>
        </html>
      `);
      } else if (contentType === "application/pdf") {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              body { margin: 0; padding: 0; }
              iframe { width: 100%; height: 100vh; border: none; }
            </style>
          </head>
          <body>
            <iframe src="${fileURL}" type="application/pdf"></iframe>
          </body>
        </html>
      `);
      } else if (contentType.startsWith("text/")) {
        const text = await response.data.text();
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Text Preview</title>
            <style>
              body { 
                font-family: monospace; 
                padding: 20px; 
                background-color: #f8f8f8;
                line-height: 1.4;
              }
              pre { 
                white-space: pre-wrap; 
                word-wrap: break-word; 
              }
            </style>
          </head>
          <body>
            <pre>${text}</pre>
          </body>
        </html>
      `);
      } else {
        newWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>File Preview</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                padding: 20px; 
                text-align: center;
                background-color: #f0f0f0;
              }
              .container {
                max-width: 400px;
                margin: 50px auto;
                padding: 30px;
                background: white;
                border-radius: 8px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .download-btn {
                background-color: #007bff;
                color: white;
                padding: 10px 20px;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                text-decoration: none;
                display: inline-block;
                margin-top: 20px;
              }
              .download-btn:hover {
                background-color: #0056b3;
              }
            </style>
          </head>
          <body>
            <div class="container">
              <h3>File Preview</h3>
              <p>This file type cannot be previewed directly.</p>
              <p>Content Type: ${contentType}</p>
              <a href="${fileURL}" download class="download-btn">Download File</a>
            </div>
          </body>
        </html>
      `);
      }

      newWindow.document.close();

      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 10000);
    } catch (error) {
      console.error("Error viewing document:", error);
      showSnackbar("Failed to view document");
    }
  };

  const handleDownloadDocument = async (attachmentId, fileName) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/barrel/indent/${indentId}/attachments/${attachmentId}/download`,
        {
          headers: { Authorization: authKey },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
      showSnackbar("Document downloaded successfully");
    } catch (error) {
      console.error("Error downloading document:", error);
      showSnackbar("Error downloading document");
    }
  };

  const getFileIcon = (fileType) => {
    const type = fileType?.toLowerCase();
    switch (type) {
      case "pdf":
        return <BsFiletypePdf size={40} color="#dc3545" />;
      case "jpg":
      case "jpeg":
        return <BsFiletypeJpg size={40} color="#007bff" />;
      case "png":
        return <BsFiletypePng size={40} color="#28a745" />;
      default:
        return <AiOutlineFile size={40} color="#6c757d" />;
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = statusOptions.find((s) => s.value === status) || {
      color: "#6c757d",
      label: status || "Unknown",
    };

    return (
      <span
        style={{
          backgroundColor: `${statusConfig.color}20`,
          color: statusConfig.color,
          padding: "6px 16px",
          borderRadius: "12px",
          fontSize: "14px",
          fontWeight: "600",
          display: "inline-block",
          border: `1px solid ${statusConfig.color}40`,
        }}
      >
        {statusConfig.label}
      </span>
    );
  };

  const getDocumentByType = (type) => {
    return (
      indentData?.attachments?.find((att) => att.document_type === type) || null
    );
  };

  const renderDocumentCard = (document, title) => {
    if (!document) return null;

    return (
      <div style={{ marginBottom: "30px" }}>
        <h5
          style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "600" }}
        >
          {title}
        </h5>
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <div
            style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
          >
            {/* File Icon */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {getFileIcon(document.file_type)}
            </div>

            {/* Document Details */}
            <div style={{ flex: 1 }}>
              <div style={{ marginBottom: "12px" }}>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "5px",
                  }}
                >
                  {document.file_name}
                </div>
                <div style={{ fontSize: "13px", color: "#666" }}>
                  Uploaded on {formatDate(document.uploaded_at)}
                </div>
              </div>

              <div
                style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
              >
                <div>
                  <span
                    style={{
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    {document.file_type}
                  </span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    Size:
                  </span>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#333",
                      fontWeight: "600",
                    }}
                  >
                    {formatFileSize(document.file_size)}
                  </span>
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  type="button"
                  onClick={() => handleViewDocument(document.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0056b3")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#007bff")
                  }
                >
                  <AiOutlineEye size={18} />
                  View
                </button>

                <button
                  type="button"
                  onClick={() =>
                    handleDownloadDocument(document.id, document.file_name)
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#218838")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#28a745")
                  }
                >
                  <FiDownload size={18} />
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoading) {
    return (
      <div className="purchase_indent_popup-overlay">
        <div
          className="purchase_indent_popup-modal"
          style={{ maxWidth: "1000px" }}
        >
          <div style={{ padding: "40px", textAlign: "center" }}>
            <div className="loader"></div>
            <div>Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!indentData) return null;

  const { indent, items, attachments, invoice_details } = indentData;
  const ioclApproval = getDocumentByType("IOCL Approval");
  const invoiceDoc = getDocumentByType("Invoice");
  const acknowledgmentDoc = getDocumentByType("Acknowledgement");

  return (
    <div className="purchase_indent_popup-overlay">
      <div
        className="purchase_indent_popup-modal"
        style={{ maxWidth: "1000px", maxHeight: "90vh", overflow: "auto" }}
      >
        <div className="purchase_indent_popup-header">
          <div>
            <h4>Purchase Indent Details</h4>
            <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
              {indent?.indent_number || "N/A"}
            </p>
          </div>
          <span className="purchase_indent_close-btn" onClick={onClose}>
            <IoClose />
          </span>
        </div>

        <div className="purchase_indent_popup-body" style={{ padding: "30px" }}>
          {/* Status and Basic Info Section */}
          <div style={{ marginBottom: "30px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
                Basic Information
              </h5>
              {getStatusBadge(indent?.indent_status)}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px",
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Indent Number
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.indent_number || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Indent Date
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {formatDateOnly(indent?.indent_date)}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Expected Delivery
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {formatDateOnly(indent?.expected_delivery_date)}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Created Date
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {formatDate(indent?.created_at)}
                </div>
              </div>
            </div>
          </div>

          {/* Customer Information */}
          <div style={{ marginBottom: "30px" }}>
            <h5
              style={{
                margin: "0 0 15px 0",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Customer Information
            </h5>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px",
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Customer Name
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.customer_name || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  SAP Code
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.sap_code || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Customer Type
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.customer_type || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Email
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.email || "N/A"}
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginBottom: "5px",
                    fontWeight: "500",
                  }}
                >
                  Contact Number
                </div>
                <div style={{ fontSize: "15px", fontWeight: "600" }}>
                  {indent?.contact_number || "N/A"}
                </div>
              </div>
            </div>
          </div>

          {/* Products Section */}
          <div style={{ marginBottom: "30px" }}>
            <h5
              style={{
                margin: "0 0 15px 0",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Products
            </h5>
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      SR
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Product Code
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Product Name
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "right",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      Quantity (KL)
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "right",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      No. of Barrels
                    </th>
                    <th
                      style={{
                        padding: "12px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#666",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      UOM
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items && items.length > 0 ? (
                    items.map((item, index) => (
                      <tr
                        key={item.id}
                        style={{
                          borderBottom:
                            index < items.length - 1
                              ? "1px solid #f0f0f0"
                              : "none",
                        }}
                      >
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {item.product_code}
                        </td>
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {item.product_name}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            textAlign: "right",
                            fontWeight: "600",
                          }}
                        >
                          {parseFloat(item.quantity).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            textAlign: "right",
                            fontWeight: "600",
                          }}
                        >
                          {parseFloat(item.quantity_in_barrels).toFixed(2)}
                        </td>
                        <td style={{ padding: "12px", fontSize: "14px" }}>
                          {item.uom}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        No products found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* IOCL Approval Document */}
          {ioclApproval && renderDocumentCard(ioclApproval, "IOCL Approval")}

          {/* Invoice Section */}
          {invoice_details && invoice_details.length > 0 && (
            <div style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  margin: "0 0 15px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Invoice Details
              </h5>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "20px",
                  backgroundColor: "#f8f9fa",
                  padding: "20px",
                  borderRadius: "8px",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginBottom: "5px",
                      fontWeight: "500",
                    }}
                  >
                    Invoice Quantity (KL)
                  </div>
                  <div style={{ fontSize: "15px", fontWeight: "600" }}>
                    {parseFloat(invoice_details[0].invoice_quantity_kl).toFixed(
                      2
                    )}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginBottom: "5px",
                      fontWeight: "500",
                    }}
                  >
                    No. of Barrels
                  </div>
                  <div style={{ fontSize: "15px", fontWeight: "600" }}>
                    {invoice_details[0].barrel_count}
                  </div>
                </div>
              </div>

              {invoiceDoc && renderDocumentCard(invoiceDoc, "Invoice Document")}
            </div>
          )}

          {/* Acknowledgment Document */}
          {acknowledgmentDoc &&
            renderDocumentCard(acknowledgmentDoc, "Acknowledgment")}
        </div>

        <div className="purchase_indent_popup-footer">
          <button
            className="purchase_indent_btn purchase_indent_btn-cancel"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewPurchaseIndent;
